import { FunctionComponent, useState } from "react";
import { OldAccountScreensProps } from "../useOldAccountDetails";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import Lottie from "react-lottie";
import dotLoading from "./assets/Dot loading.json";
import loadingAndVerified from "../../../assets/Dot loading and verified.json";
import { BodyLargeRegular, HeadlineMedium } from "../../../components/font";
import Spacing from "../../../layout/spacing";

const FlashLoadingScreen: FunctionComponent<OldAccountScreensProps> = (props: OldAccountScreensProps) => {
  const { currentSourceAccountStep, partnerConfig, onClickContinue, setIsOldAccountAnimationLoaded } = props;

  const [animationStep, setAnimationStep] = useState<number>(0);

  const finishAccountLoading = () => {
    setIsOldAccountAnimationLoaded(true);
    setAnimationStep(1);
  };

  const finishLoading = () => {
    onClickContinue();
  };

  return (
    <TransitionWrapper>
      <ScrollableContainer name={currentSourceAccountStep}>
        <Container>
          <Spacing vertical="30" />
          {animationStep === 0 ? (
            <Lottie
              options={{
                loop: false,
                autoplay: true,
                animationData: dotLoading,
              }}
              style={{ width: 200, height: 200 }}
              eventListeners={[
                {
                  eventName: "complete",
                  callback: finishAccountLoading,
                },
              ]}
            />
          ) : (
            <Lottie
              options={{
                loop: false,
                autoplay: true,
                animationData: loadingAndVerified,
              }}
              style={{ width: 200, height: 200 }}
              eventListeners={[
                {
                  eventName: "complete",
                  callback: finishLoading,
                },
              ]}
            />
          )}
          {animationStep === 0 ? (
            <>
              <HeadlineMedium className="text-center">Just a moment...</HeadlineMedium>
              <Spacing vertical="15" />
              <BodyLargeRegular className="text-center">
                Checking with {partnerConfig} to verify your old account details.
              </BodyLargeRegular>
            </>
          ) : (
            <HeadlineMedium className="text-center">Account verified</HeadlineMedium>
          )}
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};

export default FlashLoadingScreen;
